import React, { useState, useEffect } from 'react';
import { List, SpinLoading, Toast } from 'antd-mobile';
import { Empty } from 'antd';

import {
    MoreOutlined
} from '@ant-design/icons';
import 'moment/locale/ru';

import { Action, errorCatch, useAuth } from 'fennec-ui'
import { DropdownMobile } from 'fennec-ui'
import { GET, POST } from 'fennec-ui'
import { ModelMobile } from 'fennec-ui';
import AddAdminOrg from '../../../desktop/forms/AddAdminOrg';

const Item = List.Item;


export default function AdminOrg(props) {
    const auth = useAuth();
    const { object, subheader } = props;

    const [loading, setLoading] = useState(false);
    const [adminList, setAdminList] = useState([]);

    useEffect(() => {
        auth.fetch(`/api/org/admin/list/${object.ID}`).then(res => {
            if (res && res.data) {
                setAdminList(res.data);
            }
        });
    }, []);

    const admin_delete = (admin) => {
        setLoading(true);
        GET(auth, `/api/delete/org/admin/${admin.ID}`,
            () => {
                setLoading(false);
                var k = [...adminList];
                k.splice(k.findIndex(e => e.ID === admin.ID), 1);
                setAdminList(k);
            },
            (err) => errorCatch(err, setLoading(false))
        );
    };
    const columns = () => {
        var c = [];
        c.push({
            title: 'Пользователь',
            render: (text, record) => {
                return (
                    <div>
                        {record.user.lastname + " " + record.user.firstname}
                    </div>
                );
            },
            key: 'user',
        });
        c.push({
            title: 'Email',
            render: (text, record) => {
                return (
                    <div>
                        {record.user.email}
                    </div>
                );
            },
            key: 'email',
        });
        c.push({
            title: '',
            dataIndex: '',
            key: 'x',
            fixed: 'right',
            width: 45,
            render: (text, record) => {
                return (
                    <DropdownMobile
                        titles={{
                            header: "Администраторы организатора",
                            subheader: (record) ? record.user.lastname + " " + record.user.firstname : "",
                        }}
                        icon={<MoreOutlined />}
                        buttonStyle={{ border: "none" }}
                        items={() => [
                            {
                                ...props, auth: props.auth, object: record, title: "Удалить",
                                form: undefined,
                                action: (values, unlock, close) => {
                                    admin_delete(record);
                                    close();
                                },
                            },
                        ]} />
                );
            },
        });

        return c;
    };
    const addAdminOrg = (values, unlock, close) => {
        setLoading(true);
        GET(auth, `/api/add/org/${object.ID}/admin/${values.search.ID}`,
            ({ data }) => {
                setLoading(false);
                if (data) {
                    setAdminList([...adminList, data]);
                }
                close();
            },
            (err) => errorCatch(err, setLoading(false)));
    };
    const list = (data, columns) => (<>
        {loading === true && <div style={{
            width: "100%",
            minHeight: "150px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        }}>
            <SpinLoading style={{ '--size': '32px' }} />
        </div>}
        {loading === false && <List className="my-list">
            {data.length <= 0 && <div><Empty description={"Нет данных"} style={{ padding: "40px 0px" }} /></div>}
            {data.length > 0 && data.map((e, idx) => (
                <Item key={idx} multipleLine extra={columns[columns.length - 1].render("", e, idx)} align="top" wrap>
                    {columns[0].render("", e, idx)}
                    {columns.filter((el, inx) => inx > 0 && inx < columns.length - 1).map((element, i) => {
                        return <div key={i}>{element.render("", e, idx)}</div>
                    })}
                </Item>
            ))}
        </List>}
    </>);
    return (
        <div style={{ paddingTop: "15px" }}>
            <Action
                readonly={false}
                triggerStyle={{ marginBottom: "5px", textAlign: "center", fontSize: "14px" }}
                triggerOptions={{
                    type: "primary",
                    loading: loading.toString(),
                    size: "small"
                }}
                auth={auth}
                titles={{
                    header: "Добавить администратора",
                    subheader: subheader,
                }}
                action={addAdminOrg}
                steps={[
                    {
                        key: "search",
                        name: "Шаг 1",
                        form: ModelMobile,
                        action: (values, unlock, close) => {
                            POST(auth, "/api/find/finduserfilter", { ...values },
                                ({ data }) => {
                                    close(data);
                                },
                                (err) => {
                                    Toast.show({
                                        icon: 'fail',
                                        content: err.message || err.exception,
                                    })
                                    unlock();
                                });
                        },
                        meta: [
                            {
                                label: "Email",
                                name: "Email",
                                type: "string",
                                display: (v) => v,
                            },
                            {
                                label: "Фамилия",
                                name: "Lastname",
                                type: "string",
                                display: (v) => v,
                            },
                            {
                                label: "Имя",
                                name: "Firstname",
                                type: "string",
                                display: (v) => v,
                            },
                        ],
                    },
                    {
                        key: "select",
                        name: "Шаг 2",
                        noAntForm: true,
                        form: (props) => {
                            return (
                                <div>
                                    <div>Подтвердите выбор пользователя:</div>
                                    <div>ФИО: <span style={{ color: "#000" }}>{(props.data) ? props.data.search.firstname + " " + props.data.search.lastname : ""}</span></div>
                                    <div>Email: <span style={{ color: "#000" }}>{(props.data) ? props.data.search.email : ""}</span></div>
                                </div>
                            )
                        },
                    }
                ]}
            />
            {/* <Action
                readonly={false}
                triggerStyle={{ marginBottom: "5px", textAlign: "center", fontSize: "14px" }}
                triggerOptions={{
                    type: "primary",
                    loading: loading.toString(),
                    size: "small"
                }}
                auth={auth}
                titles={{
                    header: "Добавить администратора",
                    subheader: subheader,
                }}
                action={addAdminOrg}
                // form={AddAdminOrg}
                form={ModelMobile}
                meta={[
                    {
                        label: "Пользователь",
                        name: "userID",
                        duplex: "user",
                        type: "action",
                        display: (v) => {
                            return v.firstname + " " + v.lastname
                        },
                        modify: (values) => {
                            return values.search.ID;
                        },
                        modifyDuplex: (values) => {
                            return values.search;
                        },
                        steps: [
                            {
                                key: "search",
                                name: "Шаг 1",
                                form: ModelMobile,
                                action: (values, unlock, close) => {
                                    POST(auth, "/api/find/finduserfilter", { ...values },
                                        ({data}) => {
                                            close(data);
                                        },
                                        (err) => {
                                            Toast.show({
                                                icon: 'fail',
                                                content: err.message || err.exception,
                                            })
                                            unlock();
                                        });
                                },
                                meta: [
                                    {
                                        label: "Email",
                                        name: "Email",
                                        type: "string",
                                        display: (v) => v,
                                    },
                                    {
                                        label: "Фамилия",
                                        name: "Lastname",
                                        type: "string",
                                        display: (v) => v,
                                    },
                                    {
                                        label: "Имя",
                                        name: "Firstname",
                                        type: "string",
                                        display: (v) => v,
                                    },
                                ],
                            },
                            {
                                key: "select",
                                name: "Шаг 2",
                                noAntForm: true,
                                form: (props) => {
                                    return (
                                        <div>
                                            <div>Подтвердите выбор пользователя:</div>
                                            <div>ФИО: <span style={{ color: "#000" }}>{(props.data) ? props.data.search.firstname + " " + props.data.search.lastname : ""}</span></div>
                                            <div>Email: <span style={{ color: "#000" }}>{(props.data) ? props.data.search.email : ""}</span></div>
                                        </div>
                                    )
                                },
                            }
                        ]
                    },
                ]}

            /> */}
            {list(adminList, columns())}
        </div>
    );
}
